import * as glamor from 'glamor';

export const Delay = props => {
  const delay = glamor.css.keyframes({
    '0%': { opacity: '0'},
    '50%': { opacity: '0.5'},
    '99%': { opacity: '1'},
    '100%': { opacity: '1'},
  });
  return {animation: `${delay} 2s`, opacity: '1'};
};
